import {Button} from '@hm/fundamental'
import {mdiArrowLeft, mdiArrowRight, mdiCheck, mdiClose} from '@mdi/js'
import {Stack, useMediaQuery, useTheme} from '@mui/material'

import {type UseStepActions, useWidgetTranslation} from '../hooks'

type Props = {
  stepActions: UseStepActions
  onCancel?: () => void
  onGoToPrevStep?: () => void
  isValid?: boolean
  isSubmitting?: boolean
  readOnly?: boolean
  backToTargetLabel: string
}

export const StepFormActions = ({
  stepActions,
  onCancel,
  onGoToPrevStep,
  isValid,
  isSubmitting,
  readOnly,
  backToTargetLabel
}: Props) => {
  const {t} = useWidgetTranslation()
  const disabledSubmit = !isValid || isSubmitting
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Stack
      direction={isSmall ? 'column-reverse' : 'row'}
      flexWrap="wrap"
      spacing={1}
      justifyContent="space-between"
      alignItems="center"
      useFlexGap
      width="100%"
    >
      {stepActions.canGoToPrevStep ? (
        <Stack width={{xs: '100%', sm: 'auto'}}>
          <Button
            type="button"
            onClick={onGoToPrevStep}
            icon={mdiArrowLeft}
            variant="secondary"
            data-test-id="step-form-previous-button"
          >
            {t('button.previous')}
          </Button>
        </Stack>
      ) : (
        <span style={{minWidth: 60}} />
      )}
      <Stack
        direction={isSmall ? 'column-reverse' : 'row'}
        spacing={1}
        width={{xs: '100%', sm: 'auto'}}
      >
        {stepActions.canGoToNextStep ? (
          <>
            {!stepActions.canGoToPrevStep && (
              <Button
                type="button"
                onClick={onCancel}
                icon={mdiClose}
                variant="secondary"
                data-test-id="step-form-cancel-button"
              >
                {t('button.cancel')}
              </Button>
            )}
            <Button
              key="next-button"
              type="submit"
              variant="secondary"
              icon={mdiArrowRight}
              iconPosition="right"
              data-test-id="step-form-next-button"
            >
              {t('button.next')}
            </Button>
          </>
        ) : (
          <>
            {readOnly ? (
              <Button
                key="back-to-checklist-details-button"
                type="button"
                onClick={onCancel}
                icon={mdiArrowRight}
                iconPosition="right"
              >
                {backToTargetLabel}
              </Button>
            ) : (
              <Button
                key="submit-button"
                type="submit"
                icon={mdiCheck}
                disabled={disabledSubmit || isSubmitting}
                data-test-id="step-form-send-button"
              >
                {t('button.submitChecklist')}
              </Button>
            )}
          </>
        )}
      </Stack>
    </Stack>
  )
}
